import { Tag } from '../Tag';

function CardPaymentTag() {
  return (
    <Tag text="Card Payment" textColor="GREY_DARK" bgColor="GREY_LIGHTER" />
  );
}

export { CardPaymentTag };
